import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotFoundError } from '@fitness-force/models';;

import type { CreateReportFilterRequest, CreateResponse, GetReportRequest, LongReportRequest, ReportFilter, ReportResponse, ScheduleFilterDeleteRequest, ScheduleReportFilterRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { AppErrors } from '@fitness-force/models';;
import { catchError, map, Observable, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class ReportFilterService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  GetReportByKey(getReportRequest: GetReportRequest): Observable<ReportResponse> {
    return this.http
      .get(`${environment.REPORT_URL}/tenants/${getReportRequest.tenant_id}/reports/${getReportRequest.report_key}?rpt_fltr_relative_date_range=${getReportRequest.rpt_fltr_relative_date_range}&rpt_fltr_payload=${getReportRequest.rpt_fltr_payload}`,
      {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetAnalyticsReportByKey(getReportRequest: GetReportRequest): Observable<ReportResponse> {
    return this.http
      .get(`${environment.REPORT_URL}/tenants/${getReportRequest.tenant_id}/analytics/${getReportRequest.analytics_path_param}?rpt_fltr_relative_date_range=${getReportRequest.rpt_fltr_relative_date_range}&rpt_fltr_payload=${getReportRequest.rpt_fltr_payload}`,
      {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  /**
   *
   * To be moved to some common functions area
   * @returns
   */


  downloadfile(getReportRequest: any, data: any):Observable<any> {
    const formDataForExport: FormData = new FormData();
    formDataForExport.append('export', 'ALL');

    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.DOWNLOAD_REPORT_EXCEL
      .replace('{tenant_id}', getReportRequest.tenant_id.toString())
      .replace('{report_key}', getReportRequest.report_key), formDataForExport, {
      headers: { 'Content-Type': 'application/json','Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9' },
      responseType: 'blob',
      observe: 'response'
    });
  }

  GetReportExcelByKey(getReportRequest: any, data: any): Observable<any> {
    return this.http
      .post(
        `${environment.REPORT_URL}/tenants/${getReportRequest.tenant_id}/reports/${getReportRequest.report_key}/excel`,
        data,
        {
          headers: this.httpOptions.headers,
        }
      ).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {

          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  downloadFile(url:string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob',headers:{skip:"true"}})
}


  GetReportFiltersByKey(tenantId: number, reportKey: string): Observable<ReportFilter[]> {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.GET_REPORT_FILTERS
          .replace('{tenant_id}', tenantId.toString())
          .replace('{report_key}', reportKey),
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res.items;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateReportFilter(tenantId: number, reportKey: string, createReportFilter: CreateReportFilterRequest): Observable<CreateResponse> {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.CREATE_REPORT_FILTER
          .replace('{tenant_id}', tenantId.toString())
          .replace('{report_key}', reportKey),
        createReportFilter,
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateReportFilter(tenantId: number, reportKey: string, filterId: number, updateReportFilter: CreateReportFilterRequest): Observable<CreateResponse> {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.UPDATE_REPORT_FILTER
          .replace('{tenant_id}', tenantId.toString())
          .replace('{report_key}', reportKey)
          .replace('{filter_id}', filterId.toString()),
        updateReportFilter,
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  DeleteReportFilter(tenantId: number, reportKey: string, reportId: number): Observable<CreateResponse> {
    return this.http
      .delete(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.DELETE_REPORT_FILTER
          .replace('{tenant_id}', tenantId.toString())
          .replace('{report_key}', reportKey)
          .replace('{report_id}', reportId.toString()),
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ScheduleReportFilter(tenantId: number, reportKey: string, reportFilterId: number, scheduleReportPaylkoad: ScheduleReportFilterRequest): Observable<CreateResponse> {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.SCHEDULE_REPORT_FILTER
          .replace('{tenant_id}', tenantId.toString())
          .replace('{report_key}', reportKey)
          .replace('{filter_id}', reportFilterId.toString()), scheduleReportPaylkoad,
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateLongReport(tenantId: number, reportKey: string, longerReportRequest: LongReportRequest): Observable<CreateResponse> {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.CREATE_LONG_REPORT
          .replace('{tenant_id}', tenantId.toString())
          .replace('{report_key}', reportKey), longerReportRequest,
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  DeleteScheduleFilter(scheduleFilterDeleteRequest: ScheduleFilterDeleteRequest): Observable<CreateResponse> {
    return this.http
      .delete(
        environment.BASE_URL + CONST_URL_SEGEMENTS.REPORTS.DELETE_SCHEDULE_FILTER
          .replace('{tenant_id}', scheduleFilterDeleteRequest.tenant_id.toString())
          .replace('{report_key}', scheduleFilterDeleteRequest.report_key)
          .replace('{filter_id}', scheduleFilterDeleteRequest.filter_id.toString())
          .replace('{schedule_id}', scheduleFilterDeleteRequest.schedule_id.toString()),
        {
          headers: this.httpOptions.headers,
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



}
